/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Never_TestedInputs */

const en_byoa_never_tested = /** @type {(inputs: Byoa_Never_TestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never tested`)
};

const id_byoa_never_tested = /** @type {(inputs: Byoa_Never_TestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum pernah diuji`)
};

/**
* | output |
* | --- |
* | "Never tested" |
*
* @param {Byoa_Never_TestedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_never_tested = /** @type {((inputs?: Byoa_Never_TestedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Never_TestedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_never_tested(inputs)
	return en_byoa_never_tested(inputs)
});